import React from 'react'
import TabView from '../components/TabView'

const PrintTab = ({tab, data}) => <TabView tab={tab} data={data}/>

export default PrintTab
